import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, AlertController, ViewController, FabContainer  } from 'ionic-angular';
import { BarcodeScanner, BarcodeScannerOptions } from '@ionic-native/barcode-scanner';
import { BusinessRedeemHandler } from '../../providers/business-redeem-handler';

import { BusinessPunchCardRedeemPage } from '../business-punch-card-redeem/business-punch-card-redeem';
import { BusinessRewardRedeemPage } from '../business-reward-redeem/business-reward-redeem';
import { BusinessOfferRedeemPage } from '../business-offer-redeem/business-offer-redeem';

@Component({
  selector: 'page-business-qrcode-scanner',
  templateUrl: 'business-qrcode-scanner.html',
})
export class BusinessQrcodeScannerPage {
  @ViewChild('fab')fab : FabContainer;

  debugText: any;
	options: BarcodeScannerOptions;
	results: {
      text: string,
      cancelled: boolean
  };
  punchIsLoading: boolean = false
  rewardIsLoading: boolean = false
  offerIsLoading: boolean = false

  constructor(
  	public navCtrl: NavController, 
  	public navParams: NavParams, 
    public businessRedeemHandler: BusinessRedeemHandler,
  	private barcodeScanner: BarcodeScanner,
    public alertCtrl: AlertController,
    public viewCtrl: ViewController,) {

    //this.testCardData()
  }

  ionViewWillEnter(){
    // this.fab.toggleList();
    this.fab.setActiveLists(true);
  }
  
  testCardData(){
      var arr = [];

      //Punch card id
      arr.push("1")

      //User id
      arr.push("c3d17c88-3da9-466c-97d9-9cdb52c7b06f")

      this.navCtrl.push(BusinessPunchCardRedeemPage, {
          punchCardRedeem: arr
      });       
  }

  testRewardData(){
      var arr = [];

      //Reward id
      arr.push("FEBE6FB5-BAA6-4A19-822E-6D49CBA269BF")

      //User id
      arr.push("78")

      this.navCtrl.push(BusinessRewardRedeemPage, {
          rewardRedeem: arr
      });     
  }   

  testOfferData(){
      var arr = [];

      //Reward id
      arr.push("7")

      //User id
      arr.push("218")

      this.navCtrl.push(BusinessOfferRedeemPage, {
          offerRedeem: arr
      });   
  }    

  async scanPunchcard(){
    this.punchIsLoading = true

    this.options = {
      prompt: ' Scan a barcode to see the result!'
    }

    try{
      //do what i want with the data
      this.results = await this.barcodeScanner.scan(this.options);

      console.log(this.results);

      if(this.results.cancelled == true){
        this.punchIsLoading = false
        return;
      }

      var punchCardInfo = this.results.text.split("~");

      this.punchIsLoading = false

      this.navCtrl.push(BusinessPunchCardRedeemPage, {
          punchCardRedeem: punchCardInfo
      });      
    }catch(e){
      this.punchIsLoading = false
    }
  }

  async scanReward(){
    this.rewardIsLoading = true

    this.options = {
      prompt: ' Scan a reward to see the result!'
    }

    try{

      this.results = await this.barcodeScanner.scan(this.options);
      console.log(this.results);

      if(this.results.cancelled == true){
        this.rewardIsLoading = false
        return;
      }

      var rewardInfo = this.results.text.split("~");

      this.rewardIsLoading = false

      this.navCtrl.push(BusinessRewardRedeemPage, {
          rewardRedeem: rewardInfo
      });      
    }catch(e){
      this.rewardIsLoading = false
    }
  }

  async scanOffer(){
    this.offerIsLoading = true

    this.options = {
      prompt: ' Scan an offer to see the result!'
    }

    try{

      this.results = await this.barcodeScanner.scan(this.options);
      console.log(this.results);

      if(this.results.cancelled == true){
        this.offerIsLoading = false
        return;
      }

      var offerInfo = this.results.text.split("~");

      this.offerIsLoading = false

      this.navCtrl.push(BusinessOfferRedeemPage, {
          offerRedeem: offerInfo
      });      
    }catch(e){
      this.offerIsLoading = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/business-qrcode-scanner/business-qrcode-scanner.ts